import { useState, useEffect, useCallback } from 'react';

import { debounce } from 'lodash';

const useSearchDebounce = ( delay = 250 ) => {

  const [searchTerm, setSearchTerm] = useState(null);
  
  const updateSearchTerm = useCallback(debounce(async (e) => {
    let value = e?.target?.value;
    setSearchTerm(value);
  }, delay), [setSearchTerm]) 

  return {searchTerm, updateSearchTerm};
};

export default useSearchDebounce;